import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import mountScript from "@dcl/ui/esm/utilities/mountScript";
import { VIDYARD_SCRIPT_URL } from "./config";
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var vidyardException;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!window.Vidyard) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return", window.Vidyard);

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return mountScript(VIDYARD_SCRIPT_URL);

        case 5:
          _context.next = 12;
          break;

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          vidyardException = new Error("Unable to load the Vidyard API: ".concat(_context.t0));
          vidyardException.name = "VidyardLoadError";
          throw vidyardException;

        case 12:
          return _context.abrupt("return", window.Vidyard);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 7]]);
}));